jQuery(document).ready(function () {
  jQuery('body').fadeIn(1000);
});
